<template>
  <svg width="60" height="37" viewBox="0 0 60 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M57.6213 6.90738C55.5676 3.46761 49.3122 -2.14087 36.7075 2.79258C33.5111 4.02774 30.4088 5.70094 27.0027 4.55196C24.0088 3.5466 19.0479 2.13909 16.1552 0.961386C11.6716 -0.812357 6.16837 -0.0152495 3.74578 2.39762C2.27053 3.90566 -4.72245 11.2232 5.30781 22.7274C13.1252 31.7757 32.0648 36.2783 36.8811 36.5512C37.0184 36.5585 37.156 36.5585 37.2933 36.5512C38.3708 36.6086 38.9999 36.5871 38.9999 36.5871C41.0031 36.5296 32.4915 32.5513 31.9419 31.6895C35.8469 31.1366 56.8403 28.5011 58.9809 13.7366C59.3386 11.3726 58.858 8.95849 57.6213 6.90738Z"
      fill="#00B4D2"
    />
  </svg>
</template>
